import Enrollment from './Enrollment.gql';

export default Enrollment;
